import moment from 'moment';

export default (formValues, stepNum, marketingData, revisitingLead) => {
  let data = {};

  switch (stepNum) {
    case 6:
      /* Accepted Info Sheet */
      data.tags = [process.env.REACT_APP_TAG_ACCEPTED_INFO_SHEET_ID];
      data.custom_fields = [
        {
          id: process.env.REACT_APP_CF_INFO_SHEET_READ_ID,
          value: formValues.stp6_infoSheetRead.toString()
        },
        {
          id: process.env.REACT_APP_CF_INFO_SHEET_READ_DATE_ID,
          value: formValues.stp6_infoSheetReadTS
        }
      ];
      return marketingData ? Object.assign(data, marketingData) : data;
    case 7:
      /* Accepted DBA */
      data.tags = [process.env.REACT_APP_TAG_ACCEPTED_DBA_ID];
      data.custom_fields = [
        {
          id: process.env.REACT_APP_CF_DBA_AGREED_ID,
          value: formValues.stp7_dbaAgreed.toString()
        },
        {
          id: process.env.REACT_APP_CF_DBA_AGREED_DATE_ID,
          value: formValues.stp7_dbaAgreedTS
        },
        {
          id: process.env.REACT_APP_CF_DBA_AGREED_SIGNATURE_ID,
          value: formValues.stp7_dbaAgreedSignature
        }
      ];
      if (revisitingLead) data.custom_fields.push({ id: process.env.REACT_APP_CF_ANONYMOUS_DBA_ID, value: 'Yes' });
      return marketingData ? Object.assign(data, marketingData) : data;
    case 9:
      /* ID Docs Uploaded */
      data.tags = [process.env.REACT_APP_TAG_ID_DOCS_UPLOADED_ID];
      return marketingData ? Object.assign(data, marketingData) : data;
    case 'PAYSLIP':
      /* Fully Onboarded Claimant */
      data.tags = [process.env.REACT_APP_TAG_FULLY_ONBOARDED_ID];
      data.custom_fields = [
        {
          id: process.env.REACT_APP_CF_AQ_TYPE_ID,
          value: formValues.aq_type
        },
        {
          id: process.env.REACT_APP_CF_AQ_PAYSLIP_LINK_ID,
          value: formValues.aq_payslip_link
        },
        {
          id: process.env.REACT_APP_CF_AQ_JOB_TITLE_ID,
          value: formValues.aq_jobTitle
        },
        {
          id: process.env.REACT_APP_CF_AQ_NI_NUMBER_ID,
          value: formValues.aq_nationalInsurance
        },
        {
          id: process.env.REACT_APP_CF_AQ_START_DATE_ID,
          value: formValues.aq_dateStarted
        },
        {
          id: process.env.REACT_APP_CF_AQ_END_DATE_ID,
          value: formValues.aq_dateEnded
        },
        {
          id: process.env.REACT_APP_CF_AQ_JOB_CHANGED_ID,
          value: formValues.aq_jobChangedLastSixYears
        }
      ];
      if (formValues.aq_maidenName.length) {
        data.custom_fields.push({
          id: process.env.REACT_APP_CF_AQ_MAIDEN_NAME_ID,
          value: formValues.aq_maidenName
        })
      };
      return marketingData ? Object.assign(data, marketingData) : data;
    case 'QUESTIONNAIRE':
      /* Fully Onboarded Claimant */
      data.tags = [process.env.REACT_APP_TAG_FULLY_ONBOARDED_ID];
      data.custom_fields = [
        {
          id: process.env.REACT_APP_CF_AQ_TYPE_ID,
          value: formValues.aq_type
        },
        {
          id: process.env.REACT_APP_CF_AQ_EMPLOY_NUMBER_ID,
          value: formValues.aq_employeeNum
        },
        {
          id: process.env.REACT_APP_CF_AQ_JOB_TITLE_ID,
          value: formValues.aq_jobTitle
        },
        {
          id: process.env.REACT_APP_CF_AQ_NI_NUMBER_ID,
          value: formValues.aq_nationalInsurance
        },
        {
          id: process.env.REACT_APP_CF_AQ_START_DATE_ID,
          value: formValues.aq_dateStarted
        },
        {
          id: process.env.REACT_APP_CF_AQ_END_DATE_ID,
          value: formValues.aq_dateEnded
        },
        {
          id: process.env.REACT_APP_CF_AQ_JOB_CODE_ID,
          value: formValues.aq_jobCode
        },
        {
          id: process.env.REACT_APP_CF_AQ_BRANCH_NAME_ID,
          value: formValues.aq_branchName
        },
        {
          id: process.env.REACT_APP_CF_AQ_BRANCH_NUMBER_ID,
          value: formValues.aq_branchNumber
        },
        {
          id: process.env.REACT_APP_CF_AQ_BRANCH_PC_ID,
          value: formValues.aq_branchAddress
        },
        {
          id: process.env.REACT_APP_CF_AQ_HOURLY_PAY_ID,
          value: formValues.aq_hourlyPay
        },
        {
          id: process.env.REACT_APP_CF_AQ_HOURS_WEEK_ID,
          value: formValues.aq_hoursPerWeek
        },
        {
          id: process.env.REACT_APP_CF_AQ_JOB_CHANGED_ID,
          value: formValues.aq_jobChangedLastSixYears
        }
      ];
      if (formValues.aq_maidenName.length) {
        data.custom_fields.push({
          id: process.env.REACT_APP_CF_AQ_MAIDEN_NAME_ID,
          value: formValues.aq_maidenName
        })
      };
      return marketingData ? Object.assign(data, marketingData) : data;
    case 'PREVIOUS_JOBS':
      /* Fully Onboarded Claimant */
      data.tags = [process.env.REACT_APP_TAG_FULLY_ONBOARDED_ID];
      data.custom_fields = [
        {
          id: process.env.REACT_APP_CF_AQ_TYPE_ID,
          value: formValues.aq_type
        },
        {
          id: process.env.REACT_APP_CF_AQ_PAYSLIP_LINK_ID,
          value: formValues.aq_payslip_link
        },
        {
          id: process.env.REACT_APP_CF_AQ_EMPLOY_NUMBER_ID,
          value: formValues.aq_employeeNum
        },
        {
          id: 'goo9nZTUY',
          value: formValues.aq_jobTitle
        },
        {
          id: '2ZAy6TyE5',
          value: formValues.aq_nationalInsurance
        },
        {
          id: 'QWzlqoCxE',
          value: formValues.aq_dateStarted
        },
        {
          id: '1ymE3VTRr',
          value: formValues.aq_dateEnded
        },
        {
          id: 'T3qREmb2s',
          value: formValues.aq_jobCode
        },
        {
          id: 'smCk7uqOL',
          value: formValues.aq_branchName
        },
        {
          id: 'shoH3wRda',
          value: formValues.aq_branchNumber
        },
        {
          id: '8jZURElTm',
          value: formValues.aq_branchAddress
        },
        {
          id: 'JhkW8iR9F',
          value: formValues.aq_hourlyPay
        },
        {
          id: '4Ip6QnT29',
          value: formValues.aq_hoursPerWeek
        },
        {
          id: 'yHEtEbbWb',
          value: formValues.aq_jobChangedLastSixYears
        },
        {
          id: 'M0n_XcbCC',
          value: formValues.aq_prevJobTitle
        },
        {
          id: 'OvWRbaeq6',
          value: formValues.aq_prevDateStarted
        },
        {
          id: 'elZEnIWpp',
          value: formValues.aq_prevDateEnded
        },
        {
          id: 'vNhiSw5Ih',
          value: formValues.aq_prevJobCode
        },
        {
          id: 'xPT-N3I-St',
          value: formValues.aq_prevBranchName
        },
        {
          id: 'zZd1lI3xg',
          value: formValues.aq_prevBranchNumber
        },
        {
          id: 'bqATyvmot',
          value: formValues.aq_prevBranchAddress
        },
        {
          id: 'ncfZUOnHh',
          value: formValues.aq_prevHourlyPay
        },
        {
          id: 'iD_adcOqy',
          value: formValues.aq_prevHoursPerWeek
        },
        {
          id: 'Sshd5Kx5y',
          value: formValues.aq_additionalInfo
        }
      ];
      if (formValues.aq_maidenName.length) {
        data.custom_fields.push({
          id: 'H2rCc7FbX',
          value: formValues.aq_maidenName
        })
      };
      return marketingData ? Object.assign(data, marketingData) : data;
    //default is the first POST
    default:
      /* Completed Initial Registration */
      data.tags = [process.env.REACT_APP_TAG_COMPL_INIT_REG_ID];
      data.custom_fields = [
        {
          id: process.env.REACT_APP_CF_WORKED_THERE_ID,
          value: formValues.stp1_worked
        },
        {
          id: process.env.REACT_APP_CF_START_DATE_ID,
          value: formValues.stp2_startDate
        },
        {
          id: process.env.REACT_APP_CF_STILL_WORK_ID,
          value: formValues.stp2_stillWorkThere
        },
        {
          id: process.env.REACT_APP_CF_END_DATE_ID,
          value: formValues.stp2_endDate
        },
        {
          id: process.env.REACT_APP_CF_PERMISSION_AGREED_ID,
          value: `Permission Statement agreed: ${formValues.stp5_consentPermission.toString()}`
        },
        {
          id: process.env.REACT_APP_CF_PRIVACY_AGREED_ID,
          value: `Privacy Statement agreed: ${formValues.stp5_consentPrivacy.toString()}`
        },
        {
          id: process.env.REACT_APP_CF_IDENTITY_AGREED_ID,
          value: `Identity Statement agreed: ${formValues.stp5_consentIdentity.toString()}`
        },
        {
          id: process.env.REACT_APP_CF_AQ_NI_NUMBER_ID,
          value: formValues.stp4_nationalInsurance
        }
      ];
      return Object.assign(data, {
        address_postcode: formValues.stp3_postCode,
        address_street: `${formValues.stp3_houseNumName} ${formValues.stp3_streetRoad}`,
        address_location: formValues.stp3_town,
        address_country: formValues.stp3_country,
        title: formValues.stp4_title,
        first_name: formValues.stp4_firstName,
        last_name: formValues.stp4_lastName,
        email: formValues.stp4_emailAddress,
        phone: formValues.stp4_telephone,
        birthdate: moment(formValues.stp4_dob, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        gender: formValues.stp4_gender,
        //always send marketing data in initial POST
        ...marketingData
      });
  }
};
